import { render, staticRenderFns } from "./finishMicrowaveModal.vue?vue&type=template&id=0c60185c&scoped=true&"
import script from "./finishMicrowaveModal.vue?vue&type=script&lang=js&"
export * from "./finishMicrowaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c60185c",
  null
  
)

export default component.exports